export function nestCategories(data) {
    const nestedData = [];
    const lookup = {};
    // Create a lookup table using the 'id' property as the key
    data.forEach(item => {
        lookup[item.id] = Object.assign(Object.assign({}, item), { children: [] });
    });
    // Iterate through the data to build the nested structure
    data.forEach(item => {
        if (item.parentId === null) {
            // If it's a top-level item, add it directly to the result
            nestedData.push(lookup[item.id]);
        }
        else {
            // If it has a parent, push it to the parent's 'children' array
            lookup[item.parentId].children.push(lookup[item.id]);
        }
    });
    return nestedData;
}
